import { CustomLink, styled, ListContent } from '@teko/ds-desktop';
import { CheckOutlined } from '@teko/ds-icon';
import React, { useState, useEffect } from 'react';
import { getTrackingData } from '@teko/tracking';
import { TopbarButton } from './TopbarButton.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var DropdownTheme = /* @__PURE__ */ ((DropdownTheme2) => {
  DropdownTheme2[DropdownTheme2["LANGUAGE"] = 0] = "LANGUAGE";
  DropdownTheme2[DropdownTheme2["MENU"] = 1] = "MENU";
  return DropdownTheme2;
})(DropdownTheme || {});
const TopbarDropdown = ({
  value,
  selectValue,
  options,
  href,
  tracking,
  theme = 0 /* LANGUAGE */,
  icon,
  text
}) => {
  const [show, setShow] = useState(false);
  const [activeOption, setActiveOption] = useState(options.find((option) => option.value === value));
  useEffect(() => {
    setActiveOption(options.find((option) => option.value === value));
  }, [value, options]);
  return /* @__PURE__ */ React.createElement(CustomLink, {
    href
  }, /* @__PURE__ */ React.createElement(Wrapper, {
    onMouseLeave: () => setShow(false)
  }, /* @__PURE__ */ React.createElement(TopbarButton, __spreadProps(__spreadValues({
    icon: icon || (activeOption == null ? void 0 : activeOption.icon)
  }, tracking && getTrackingData(tracking)), {
    onMouseOver: () => setShow(true)
  }), text || (activeOption == null ? void 0 : activeOption.text)), /* @__PURE__ */ React.createElement(DropdownMenu, {
    show,
    dropdownTheme: theme
  }, options.map((item, index) => /* @__PURE__ */ React.createElement(Option, {
    key: index
  }, /* @__PURE__ */ React.createElement(StyledListContent, {
    label: item.text,
    icon: item == null ? void 0 : item.icon,
    dropdownTheme: theme,
    borderRadius: "s",
    onClick: () => selectValue(item.value),
    hasDivider: [1 /* MENU */].includes(theme)
  }), [0 /* LANGUAGE */].includes(theme) && item.value === (activeOption == null ? void 0 : activeOption.value) && /* @__PURE__ */ React.createElement(CheckOutlined, {
    size: 24,
    color: "red",
    style: { position: "absolute", right: "8px" }
  }))))));
};
const Wrapper = styled.div`
  position: relative;
`;
const DropdownMenu = styled.div`
  display: ${(props) => props.show ? "block" : "none"};
  position: absolute;
  background-color: white;
  z-index: 10000;

  ${({ dropdownTheme }) => {
  switch (dropdownTheme) {
    case 1 /* MENU */:
      return ``;
    default:
      return `
          padding: 4px;
          border-radius: 4px;
          right: 20px;
          top: 35px;
          box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
          min-width: 11rem;
        `;
  }
}}
`;
const Option = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;
const StyledListContent = styled(ListContent)`
  cursor: pointer;

  ${({ dropdownTheme, theme }) => {
  switch (dropdownTheme) {
    case 1 /* MENU */:
      return `
          background-color: ${theme.colors.primary500};
          color: white;
          border-radius: unset;
          width: max-content;
          min-width: 100%;

          &:hover {
            background-color: ${theme.colors.primary600};
          }

          &:after {
            right: 0;
            left: 0;
          }
        `;
    default:
      return `
          width: 100%;
          padding: 8px 48px 8px 12px;
        `;
  }
}}
`;

export { DropdownTheme, TopbarDropdown };
